import {
  AspectRatio,
  Box,
  Button,
  Heading,
  Input,
  Text,
  HStack,
  useToast,
  VStack,
  useMediaQuery,
  FormControl,
  Center,
  FormErrorMessage,
  InputRightElement,
  FormLabel,
  InputGroup,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState, useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { BsUnlock } from "react-icons/bs";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ForgotApi, ResetPasswordApi } from "../../utils/api";
import { Field ,Formik} from "formik";
import { BiHide, BiShow } from "react-icons/bi";
const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [show, setShow] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();
  const handleSubmit = (value) => {
    ResetPasswordApi({ token, newPassword:value.password })
      .then((myres) => {
        console.log(myres);
        toast({
          title: "Reset Password",
          description: `Password has been reset successfully`,
          status: "success",
          duration: 6000,
          isClosable: true,
          position: "top",
        });
        setTimeout(() => {
          navigate("/login");
        }, 1800);
      })
      .catch((err) => {
        toast({
          title: "Error",
          description: err.response?.data?.message
            ? err.response?.data.message
            : err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top",
        });
      });
  };

  return (
    <Box w="100%">
      <VStack justify={"center"} align={"center"} minH={"80vh"} gap={"2rem"}>
        <HStack justify={"center"}>
          <Heading
            pt={"2rem"}
            display={"flex"}
            textAlign={"center"}
            gap={"1rem"}
            size="2xl"
            color="rgb(218 52 85)"
          >
            Reset Password
          </Heading>
        </HStack>
        <VStack
          w={["100%", "75%", "50%", "45%"]}
          p={["3rem 1.5rem", "4rem 2.5rem", "5rem 3rem", "3rem"]}
          align={"center"}
          border={"1.5px solid rgb(218 52 85)"}
          rounded={"0.3rem"}
        >
          <Formik
            initialValues={{
              password: "",
              confirmPassword: "",
            }}
            onSubmit={handleSubmit}
            validate={(values) => {
              const errors = {};

              if (values.password.length < 8) {
                errors.password = "Password must contain at least 8 characters";
              }

              if (!values.confirmPassword) {
                errors.confirmPassword = "Please confirm your password";
              } else if (values.password !== values.confirmPassword) {
                errors.confirmPassword = "Passwords do not match";
              }

              return errors;
            }}
          >
            {({ handleSubmit, errors, touched }) => (
              <form onSubmit={handleSubmit} style={{width:'100%'}}>
                <VStack spacing={8} align="flex-start">
                  {/* Password Field */}
                  <FormControl
                    isInvalid={!!errors.password && touched.password}
                  >
                    <FormLabel htmlFor="password">Password</FormLabel>
                    <InputGroup position={"relative"}>
                      <Field
                        as={Input}
                        id="password"
                        name="password"
                        type={show ? "text" : "password"}
                        size="lg"
                        border="2.5px solid black"
                        _hover={{ background: "#ffffff", color: "black" }}
                      />
                      <InputRightElement width="4.5rem">
                        <Center
                          fontSize="30px"
                          pt={2}
                          bg="none"
                          onClick={() => setShow(!show)}
                        >
                          {show ? (
                            <BiHide style={{ cursor: "pointer" }} />
                          ) : (
                            <BiShow style={{ cursor: "pointer" }} />
                          )}
                        </Center>
                      </InputRightElement>
                    </InputGroup>
                    <FormErrorMessage position={"absolute"}>
                      {errors.password}
                    </FormErrorMessage>
                  </FormControl>

                  {/* Confirm Password Field */}
                  <FormControl
                    isInvalid={
                      !!errors.confirmPassword && touched.confirmPassword
                    }
                  >
                    <FormLabel htmlFor="confirmPassword">
                      Confirm Password
                    </FormLabel>
                    <InputGroup position={"relative"}>
                      <Field
                        as={Input}
                        id="confirmPassword"
                        name="confirmPassword"
                        type={show ? "text" : "password"}
                        size="lg"
                        border="2.5px solid black"
                        _hover={{ background: "#ffffff", color: "black" }}
                      />
                         <InputRightElement width="4.5rem">
                        <Center
                          fontSize="30px"
                          pt={2}
                          bg="none"
                          onClick={() => setShow(!show)}
                        >
                          {show ? (
                            <BiHide style={{ cursor: "pointer" }} />
                          ) : (
                            <BiShow style={{ cursor: "pointer" }} />
                          )}
                        </Center>
                      </InputRightElement>
                    </InputGroup>
                    <FormErrorMessage position={"absolute"}>
                      {errors.confirmPassword}
                    </FormErrorMessage>
                  </FormControl>

                  <Button
                    h="48px"
                    _hover={{
                      color: "rgb(218 52 85)",
                      background: "white",
                    }}
                    type="submit"
                    bg="rgb(218 52 85)"
                    color={"white"}
                    border="1.5px solid rgb(218 52 85) !important"
                    width="full"
                  >
                    Reset Password
                  </Button>
                </VStack>
              </form>
            )}
          </Formik>
        </VStack>
      </VStack>
    </Box>
  );
};

export default ResetPassword;
